// extracted by mini-css-extract-plugin
export default {"day":"expiryDateCalendar_day__p7Z+W"};